import { post } from '../utils/http';
import { walletApiEndPoint, requestIFSCPayload } from '../utils/common';
import { API } from '../constant';

export function validateIfsc(ifscData, skipMiddleware = true) {
  return post.call(
    this,
    walletApiEndPoint(API.VALIDATE_IFSC),
    requestIFSCPayload(ifscData),
    skipMiddleware
  );
}

export function getIfsc(ifscData, skipMiddleware = true) {
  return post.call(
    this,
    walletApiEndPoint(API.GET_IFSC),
    requestIFSCPayload(ifscData),
    skipMiddleware
  );
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/bank-mandate.js